<template>
  <div class="box" >
    <el-select
      v-model="searchValue"
      clearable
      placeholder="状态"
      style="width: 100%;"
    >
      <el-option
        v-for="item in option"
        :key="item.value"
        :label="item.label"
        :value="item.value"
      >
        <div class="flex-js-ac">
              <div class="point" :class="item.value === '0' ? 'greenBack' : item.value === '1' ? 'redBack' : 'yellowBack'"></div>
              <span>{{ item.label }}</span>
            </div>
      </el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ''
    },
    option: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  watch: {
    searchValue: {
      immediate: true,
      handler: function (newVal) {
        if (newVal) {
          this.$emit('searchChange', newVal)
        }
      }
    },
    value: {
      immediate: true,
      handler: function (newVal) {
        this.searchValue = newVal
      }
    }
  },
  data () {
    return {
      searchValue: ''
    }
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.point{
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 5px;
}
.flex-js-ac{
  display: flex;
  align-items: center;
  justify-content: flex-start;
}
.width205{
  width: 205px;
}
.yellowBack{
  background: radial-gradient(circle, rgb(249, 249, 180), yellow, #7f8131);
}
.greenBack{
  background: radial-gradient(circle, #9fe09f, #40b440, #0c360c);
}
.redBack {
  background: radial-gradient(circle, #db8d92, #e03030, #561f1f);
}
</style>
